export default (context) => {
    return {
        config: {
          hiddenGrid: true
        },
      
        actions: {
          create: false,
          edit: false,
          delete: false,
          print: false,
          export: false,
          search: false
        },
      
        extras: {
          items: [],
          itemsInRowsTable: [],
          forms: [
            {
              fields: [
                  {
                  col: 12,
                  name: "dummy",
                  value: null,
                  type: "button",
                  label: "Tomar asistencia",
                  opts: {
                    style: 'float-label'
                  },
                  onClick: (ctx) => {
                    window.open("/admin/#/ActivitySession");
                  }
                }
              ],
              
              getUrl:"",
              postUrl:"",

              onSuccess: (r) => { },
              onError: (e) => { },
            }
          ]
        },
      
        filter: {
          fields: [],
          buttons: []
        },
      
        form: {
          fields: [ ]
        },
      
        columns: []
      }
    }